import { render, staticRenderFns } from "./giro.vue?vue&type=template&id=d4207c9c&scoped=true"
import script from "./giro.vue?vue&type=script&lang=js"
export * from "./giro.vue?vue&type=script&lang=js"
import style0 from "./giro.vue?vue&type=style&index=0&id=d4207c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4207c9c",
  null
  
)

export default component.exports